/**
 * Fullscreen Mode Strategy
 *
 * Display mode strategy for fullscreen popups.
 * Fullscreen popups cover the entire viewport.
 * Sizing is handled via CSS (100vw x 100vh).
 * Inner width is handled inside the iframe (passed via PHP in the iframe URL)
 * so custom CSS in the iframe can add full-width backgrounds.
 */

import type { DisplayModeStrategy } from './types';

/**
 * Strategy for fullscreen display mode.
 */
export class FullscreenModeStrategy implements DisplayModeStrategy {
	/**
	 * Returns CSS classes for fullscreen mode.
	 */
	public getDisplayModeClasses = (): string[] => {
		return ['gp-popup--fullscreen'];
	};

	/**
	 * Apply body scroll lock when popup opens.
	 */
	public applyBodyState = (): void => {
		document.body.classList.add('gp-popup-open');
	};

	/**
	 * Remove body scroll lock when popup closes.
	 * Only removes if no other popups are open.
	 */
	public removeBodyState = (): void => {
		if (!document.querySelector('.gp-popup--open')) {
			document.body.classList.remove('gp-popup-open');
		}
	};

	/**
	 * Fullscreen popups have no visible backdrop to click.
	 */
	public shouldCloseOnBackdropClick = (): boolean => {
		return false;
	};
}
